import { render, staticRenderFns } from "./WhatWeDo.vue?vue&type=template&id=fc9401ce&"
import script from "./WhatWeDo.vue?vue&type=script&lang=js&"
export * from "./WhatWeDo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports